import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiArrowUp, FiArrowUpRight } from "react-icons/fi";
import "./voices-shell.css";
import { EndingJourney } from './VoicesJourneys';
import { useMotionPreference } from './useScrollScene';
import { hasVoicesEnding } from './voicesRoutes';
import { useVoicesTheme } from './VoicesTheme';

const COLUMNS = [
  { title: "Expertise", links: [
    ["/ai-agents", "Custom AI agents"],
    ["/services/salesforce-agentforce", "Salesforce Agentforce"],
    ["/managed-agents", "Managed agents"],
    ["/services/ai-implementation", "AI implementation"],
    ["/services/agentic-enterprise-implementation", "Agentic enterprise"],
    ["/services/openai-implementation", "OpenAI implementation"],
    ["/services/claude-implementation", "Claude implementation"],
    ["/services", "All services"],
  ] },
  { title: "Our work", links: [
    ["/customer-stories/24-hour-home-care-workforce-modernization", "24 Hour Home Care"],
    ["/customer-stories/trivago-support-portal", "Trivago"],
    ["/work", "All customer stories"],
    ["/case-studies", "Architecture & insights"],
  ] },
  { title: "Antrazal", links: [
    ["/who-we-are", "Company"],
    ["/careers", "Careers"],
    ["/events", "Events"],
    ["/products/edi-converter", "EDI converter"],
  ] },
];

export default function VoicesFooter() {
  const { pathname } = useLocation();
  const { theme } = useVoicesTheme();
  const logo = `/assets/voices/antrazal-${theme === 'dark' ? 'white' : 'blue'}.webp`;
  const [reduced, toggleMotion] = useMotionPreference();
  return (
    <>
    {hasVoicesEnding(pathname) && <EndingJourney key={pathname} reduced={reduced} />}
    <footer className="voices-footer">
      <div className="voices-footer-inner">
        <div className="voices-footer-top">
          <Link to="/" className="voices-brand" aria-label="Antrazal home">
            <img src={logo} alt="Antrazal" width="125" height="28" loading="lazy" />
          </Link>
          <p>Trust. Innovation. People.</p>
          <Link to="/contact" className="voices-footer-talk">Let's talk<FiArrowUpRight aria-hidden="true" /></Link>
        </div>
        <nav className="voices-footer-links" aria-label="Footer navigation">
          {COLUMNS.map((column) => (
            <div key={column.title}>
              <h2>{column.title}</h2>
              <ul>{column.links.map(([path, label]) => <li key={path}><Link to={path}>{label}</Link></li>)}</ul>
            </div>
          ))}
        </nav>
        <div className="voices-footer-signature" aria-hidden="true">
          <img src={logo} alt="" width="900" height="203" loading="lazy" />
          <p>Trust. Innovation. People.</p>
        </div>
        <div className="voices-footer-bottom">
          <p>&copy; {new Date().getFullYear()} Antrazal</p>
          <div>
            <Link to="/privacy-policy">Privacy</Link><Link to="/site-map">Site directory</Link>
            <button type="button" onClick={event => window.dispatchEvent(new CustomEvent('voices:search', { detail: { trigger: event.currentTarget } }))}>Search</button>
            <button type="button" className="voices-footer-motion" onClick={toggleMotion} aria-pressed={reduced} aria-label={`${reduced ? 'Enable' : 'Reduce'} website motion`}>{reduced ? 'Enable' : 'Reduce'} motion</button>
            <button type="button" aria-label="Back to top" title="Back to top" onClick={() => window.scrollTo({ top: 0, behavior: reduced ? 'instant' : 'smooth' })}><FiArrowUp aria-hidden="true" /></button>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
}
